export default __webpack_public_path__ + "static/media/three_dot_sp_card.47549f35.svg";